export enum DocumentMode {
	Read = 'read',
	Write = 'write',
	Review = 'review',
};
